/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.0.5 routes of Docportal::Application.
 * @version cc1c6ba8c0eb5ac0a64ec50b76b0f5f40229aaf82952fb71eadc193dcdd276fa
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: true,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /public_terms_of_uses/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_public_terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_terms_of_uses"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_uses/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_uses"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/admins/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/admins(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admins_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/documents/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/documents(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_documents_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/education_reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/education_reports/:education_report_id/self_assessment(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} education_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_education_report_self_assessment_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"education_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"education_report_id"],[2,[7,"/"],[2,[6,"self_assessment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/education_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_education_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"education_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports/:report_id/complete_self_assessment(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_report_complete_self_assessment_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"complete_self_assessment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports/:report_id/save_self_assessment(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_report_save_self_assessment_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"save_self_assessment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_supervisor_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentice_supervisors_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentices_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/coaches/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coach_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"coaches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/coaches(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coaches_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"coaches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/companies(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/companies/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public_documents/document(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_public_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_documents"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/document_views(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const document_views_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"document_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documents_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_configurations/duplicate(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_certificate_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_configurations"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education1_configurations/duplicate(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_education1_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education1_configurations"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education2_configurations/duplicate(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_education2_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education2_configurations"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_configurations/duplicate(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_jumpstart_certificate_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_configurations"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_configurations/duplicate(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_probation_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_configurations"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/admins/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprentice_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/education_reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprentice_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprentice_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprentice_supervisor_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/coaches/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_coach_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"coaches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/companies/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/document_views/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_document_views_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"document_views"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education1_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_education1_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education1_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education2_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_education2_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education2_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /errors/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_errors_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/global_documents/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_global_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"global_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/groups/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_group_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_jumpstart_certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_jumpstart_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/observations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_observation_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"observations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_probation_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_probation_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public_document_views/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_public_document_views_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_document_views"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public_documents/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_public_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_documents"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public_terms_of_uses/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_public_terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_terms_of_uses"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/report_configurations/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_report_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"report_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/schools/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/school_days/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_day_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"school_days"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/signatures/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_signature_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_uses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_terms_of_use_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms_of_uses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/year_contexts/:id/edit(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_year_context_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"year_contexts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education1_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education1_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education1_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education1_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education1_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education1_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education2_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education2_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education2_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education2_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education2_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education2_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const education_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /errors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/export(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_apprentices_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports/generate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_certificate_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[2,[7,"/"],[2,[6,"generate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports/:id/generate_document(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_document_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports/generate_documents(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_documents_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"generate_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports/generate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_education_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[6,"generate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports/generate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_jumpstart_certificate_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[2,[7,"/"],[2,[6,"generate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports/generate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_probation_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[2,[7,"/"],[2,[6,"generate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/global_documents/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const global_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"global_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/global_documents(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const global_documents_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"global_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/groups/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const group_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/groups(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groups_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors/import(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_apprentice_supervisors_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/import(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_apprentices_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors/import_example(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_example_apprentice_supervisors_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[2,[7,"/"],[2,[6,"import_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/import_example(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_example_apprentices_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[6,"import_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jumpstart_certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jumpstart_certificate_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jumpstart_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jumpstart_certificate_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/observations/:apprentice_id/new2(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new2_observations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"observations"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"new2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/admins/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_apprentice_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/education_reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_apprentice_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:apprentice_id/reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} apprentice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_apprentice_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"apprentice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"apprentice_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentice_supervisors/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_apprentice_supervisor_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentice_supervisors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/coaches/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_coach_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"coaches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/companies/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/document_views/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_document_views_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"document_views"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education1_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_education1_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education1_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education2_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_education2_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education2_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /errors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_errors_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/global_documents/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_global_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"global_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/groups/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_group_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jumpstart_certificate_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jumpstart_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/observations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_observation_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"observations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_probation_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_probation_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public_document_views/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_document_views_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_document_views"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public_terms_of_uses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_public_terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_terms_of_uses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/report_configurations/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"report_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/schools/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/school_days/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_day_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"school_days"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/signatures/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_signature_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_uses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_terms_of_use_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_uses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/year_contexts/new(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_year_context_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"year_contexts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/observations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observation_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"observations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/observations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/apprentices/:id/observations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observations_apprentice_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"apprentices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"observations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/certificate_reports/:id/print(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"certificate_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/education_reports/:id/print(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_education_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"education_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/jumpstart_certificate_reports/:id/print(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_jumpstart_certificate_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"jumpstart_certificate_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports/:id/print(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_probation_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const probation_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const probation_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const probation_report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/probation_reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const probation_reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"probation_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /public_document_views(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_document_views_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_document_views"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /public_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /public_terms_of_uses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"public_terms_of_uses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/publish(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_documents_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/report_configurations/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_configuration_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"report_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/report_configurations(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_configurations_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"report_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/reports(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/:id/rerender(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rerender_document_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rerender"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/schools/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/school_days/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_day_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"school_days"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/school_days(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_days_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"school_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/schools(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/signatures/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/signatures(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signatures_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_uses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_use_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms_of_uses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms_of_uses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_uses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_uses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /errors/unauthorized(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unauthorized_errors_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"unauthorized"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/documents/unpublish(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_documents_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/password_reset_mail_sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_reset_mail_sent_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"password_reset_mail_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/password_token_invalid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_token_invalid_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"password_token_invalid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_activate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_deactivate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/year_contexts/:id(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const year_context_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"year_contexts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:year_starts/:year_ends/year_contexts(.:format)
 * @param {any} year_starts
 * @param {any} year_ends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const year_contexts_path = /*#__PURE__*/ __route({"year_starts":{"r":true},"year_ends":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"year_starts"],[2,[7,"/"],[2,[3,"year_ends"],[2,[7,"/"],[2,[6,"year_contexts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

